import * as angular from 'angular';
import { DirectiveDefinition } from './directiveDefinition';

class WtFocusController implements angular.IController {
    $focused = false;

    static $inject = ['$scope', '$element'];
    constructor(private $scope: angular.IScope,
        private $element: angular.IAugmentedJQuery) {
    }

    $onInit() {
        const scope = this.$scope;
        const element = this.$element;
        const self = this;

        // wt-focused is the name of the css class
        element
            .on('focus', (evt: JQueryEventObject) => {
                element.addClass('wt-focused');
                scope.$apply(() => { self.$focused = true; });
            })
            .on('blur', (evt: JQueryEventObject) => {
                element.removeClass('wt-focused');
                scope.$apply(() => { self.$focused = false; });
            });
    }
}

export const WtFocusDirective: DirectiveDefinition = {
    directiveId: 'wtFocus',
    restrict: 'A',
    controller: WtFocusController
    //require: ['ngModel'],
};